import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Diagnostic from './Diagnostic';
import MainNav from './MainNav';
// import MainSubNav from './MainSubNav';
import MainNavButtons from './MainNavButtons';
import MainNavColorBar from './MainNavColorBar';
import MainNavSearch from './MainNavSearch';
import FAQ from './FAQ';
import ProductGallery from './ProductGallery';
import ProductGalleryModal from './ProductGalleryModal';
import ProductGalleryStore from './flux/ProductGalleryStore';
// import CartStore from './flux/CartStore';

const slMainNav = document.getElementById('slMainNav');
const slMainSubNav = document.getElementById('slMainSubNav');
const slHeader = document.getElementById('shopify-section-header');
const navJSON = window.slJSONnavigation;
if (slMainNav && slMainSubNav && slHeader && navJSON) {
  ReactDOM.render( <MainNav navJSON={navJSON} slHeader={slHeader} />, slMainNav );
}

const slDiagnostic = document.getElementById('slDiagnostic');
if (slDiagnostic) {
  ReactDOM.render( <Diagnostic/>, slDiagnostic );
}

// MINI CART:
const headerIcons = document.getElementById('slHeaderIcons');
if (headerIcons && navJSON) {
  ReactDOM.render( <MainNavButtons navJSON={navJSON} />, headerIcons );
}

const headerIcons2 = document.getElementById('headerIcons2');
if (headerIcons2) {
  ReactDOM.render( <MainNavColorBar />, headerIcons2 );
}

const headerSearchBar = document.getElementById('header-search-bar');
if (headerSearchBar) {
  ReactDOM.render( <MainNavSearch />, headerSearchBar );
}

const slFAQ = document.getElementById('slFAQ');
const slJSONfaq = window.slJSONfaq;
if (slJSONfaq && slFAQ) {
  ReactDOM.render( <FAQ json={slJSONfaq} />, slFAQ );
}

const slProductGallery = document.getElementById('product-media-gallery-react');
const slProductPageInfo = window.slProductPageInfo;

// console.log(slProductGallery);
// console.log(slProductPageInfo);
// console.log(slProductGalleryModal);

const slProductGalleryModal = document.getElementById('product-media-gallery-modal');
if (slProductGallery && slProductPageInfo && slProductGalleryModal) {
  ReactDOM.hydrate( <ProductGallery json={slProductPageInfo} />, slProductGallery );
  ReactDOM.hydrate( <ProductGalleryModal />, slProductGalleryModal );
}
window.slProductGallery = (variant) => {
  // variant was changed by customer:
  if (variant) { ProductGalleryStore.setVariant(variant) }
}